<template>
  <v-toolbar color="primary" style="z-index: 999999" fixed dark app>
    <v-btn icon flat @click="goBack" :title='$t("toolbar.back")' class="ms-2">
      <v-icon>{{ $vuetify.rtl ? "arrow_forward" : "arrow_back" }}</v-icon>
    </v-btn>
    <v-toolbar-title class="ms-0 ps-3 pe-3">
      <v-toolbar-side-icon
        @click.stop="handleDrawerToggle"
      ></v-toolbar-side-icon>
      {{ $t("app.name") }}
    </v-toolbar-title>
    <!-- <v-autocomplete
      @change="goToPassengerProfile"
      :items="searchResults"
      :loading="loading"
      :search-input.sync="search"
      item-value="id"
      item-text="username"
      no-filter
      flat
      solo-inverted
      class="hidden-sm-and-down"
      label="Start typing to Search"
      prepend-inner-icon="search"
    >
      <template slot="item" slot-scope="data">
        <v-list-tile-avatar>
          <img
            :src="api.GET_IMAGE(data.item.profile_image)"
            :alt="data.item.id"
          />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title
            v-html="data.item.first_name + ' ' + data.item.last_name"
          ></v-list-tile-title>
          <v-list-tile-sub-title
            v-html="data.item.username"
          ></v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
      <v-icon>mdi-filter</v-icon>
    </v-autocomplete> -->
    <search-input />
    <v-spacer></v-spacer>

    <v-menu offset-y :left="!$vuetify.rtl" :right="$vuetify.rtl" max-width="380" min-width="300">
      <v-btn slot="activator" icon flat :title='$t("toolbar.pendingRequests")' class="notif-btn">
        <v-icon>notifications</v-icon>
        <span v-if="pendingTotal > 0" class="notif-badge">{{ pendingTotal }}</span>
      </v-btn>
      <v-card>
        <v-list dense>
          <v-subheader>{{ $t("toolbar.pendingRequests") }}</v-subheader>
          <template v-if="pendingCategories.length">
            <v-list-tile v-for="(c, i) in pendingCategories" :key="'cat' + i" @click="goToCategory(c)">
              <v-list-tile-content>
                <v-list-tile-title>{{ categoryLabel(c) }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-chip small :color="c.info ? 'grey' : 'red'" text-color="white">{{ c.count }}</v-chip>
              </v-list-tile-action>
            </v-list-tile>
          </template>
          <v-list-tile v-else>
            <v-list-tile-content>
              <v-list-tile-sub-title>{{ $t("toolbar.noPendingRequests") }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>

    <div class="toolbar-language">
      <lang-selector />
    </div>

    <v-btn icon flat :title='$t("toolbar.logout")' @click="logout">
      <v-icon>exit_to_app</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>
import SearchInput from "@/components/widgets/SearchInput.vue";
import LangSelector from "@/components/LangSelector.vue";
import { getFirstAllowedPage, canAccessRoute } from "@/utils/permissionHelpers";

export default {
  name: "app-toolbar",
  components: {
    SearchInput,
    LangSelector,
  },
  data() {
    return {
      pendingTotal: 0,
      pendingSummary: {},
      notifTimer: null,
    };
  },
  computed: {
    // Categories with at least one pending item (server already filters by the
    // signed-in admin's permissions, so we only ever receive allowed ones).
    pendingCategories() {
      return Object.values(this.pendingSummary || {}).filter((c) => c && c.count > 0);
    },
  },
  mounted() {
    this.loadPendingSummary();
    this.notifTimer = setInterval(this.loadPendingSummary, 60000);
  },
  beforeDestroy() {
    if (this.notifTimer) clearInterval(this.notifTimer);
  },
  methods: {
    // Backend sends both languages; pick by the active UI locale.
    categoryLabel(c) {
      return this.$i18n && this.$i18n.locale === "ar" ? c.label_ar || c.label : c.label;
    },
    loadPendingSummary() {
      this.axios
        .get("pending-summary")
        .then(({ data }) => {
          const d = data.data || {};
          this.pendingTotal = d.total || 0;
          this.pendingSummary = d.summary || {};
        })
        .catch(() => {});
    },
    goToCategory(c) {
      if (!c || !c.route) return;
      const target = { name: c.route };
      if (c.query) target.query = c.query;
      // Always navigate (don't bail when already on the route name: the query —
      // e.g. the pending tab — may differ from the current view).
      this.$router.push(target).catch(() => {});
    },
    goBack() {
      const userPermissions = (this.$store.state.user && this.$store.state.user.permissions) || [];
      const firstPage = getFirstAllowedPage(userPermissions);
      
      if (window.history.length > 1) {
        // Store current route before going back
        const currentRouteName = this.$route.name;
        
        // Try to go back
        this.$router.go(-1);
        
        // After navigation, check if current route is accessible
        // Use a timeout to ensure navigation is complete
        setTimeout(() => {
          const newRouteName = this.$route.name;
          
          // If we're still on the same route or don't have permission, redirect
          if (newRouteName === currentRouteName || (newRouteName && !canAccessRoute(newRouteName, userPermissions))) {
            // If we don't have permission for the page we went back to,
            // redirect to first allowed page
            this.$router.push(firstPage).catch(() => {
              // Ignore navigation errors (e.g., if already on that page)
            });
          }
        }, 100);
      } else {
        // No history, go to first allowed page
        this.$router.push(firstPage);
      }
    },
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    logout() {
      this.axios
        .put(this.api.ACTIONS.LOGOUT)
        .then(() => {
          window.getApp.$emit("APP_LOGOUT");
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", this.$t("toolbar.logoutError"));
          console.log(err);
          console.log(err.response);
          console.log(err.response.data);
        })
        .finally(() => {
          this.$store.commit("LOGOUT");
          this.$router.push({ name: "Login" });
        });
    },
  },
};
</script>

<style scoped>
.toolbar-language {
  margin-inline-end: 8px;
}

.v-toolbar {
  touch-action: pan-x pan-y !important;
  overflow: visible !important;
}

.notif-btn {
  position: relative;
}

.notif-badge {
  position: absolute;
  top: 2px;
  inset-inline-end: 2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #e53935;
  color: #fff;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  font-weight: 700;
}
</style>
